'use client';
import Button from '@/components/Button';
import { convertMessageToHtmlIfNecessary } from '@/helpers/stringFormatHelper';
import { useEffect, useState } from 'react';
import ErrorLoading from '../ErrorLoading';

/**
 * MessageToUser is a functional component in React that displays a message to the user.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.message - The message to be displayed to the user.
 * @param {boolean} [props.showMessage=true] - A flag indicating whether the message should be displayed.
 * @param {string} [props.status="info"] - The status of the message, which determines the alert style. Can be "info", "success", "warning", or "danger".
 * @param {Object} [props.position={position: 'relative', place: ''}] - The position of the alert. The 'position' property can be sticky, fixed, relative, and the 'place' property can be top or bottom.
 * @param {string} [props.className=''] - The class name to apply to the alert.
 * @param {Function} [props.onDismiss] - Callback function called when the user dismisses the message.
 *
 * @returns {JSX.Element} A div element representing the alert message.
 */
const MessageToUser = ({
  message,
  showMessage = true,
  status = 'info',
  position = { position: 'relative', place: '' },
  className = '',
  onDismiss,
}) => {
  const [showMessageState, setShowMessageState] = useState(showMessage);
  const [ShowError, setShowError] = useState(false);

  useEffect(() => {
    try {
      const messageHtml = convertMessageToHtmlIfNecessary(message);
      if (messageHtml !== message) {
        message = messageHtml;
      }
      setShowMessageState(showMessage);
    } catch (e) {
      console.error(e);
      setShowError(true);
    }
  }, [showMessage, message]);
  return (
    <>
      {ShowError ? (
        <ErrorLoading />
      ) : (
        <>
          {showMessageState && (
            <div
              className={`card alert text-${status} alert-${status} ${position.position}-${position.place}  ${className}`}
              role="alert"
            >
              <div className="card-body p-0">
                <div className="d-flex justify-content-end">
                  <Button
                    type="button"
                    className="btn-close mb-2"
                    onClick={() => {
                      setShowMessageState(false);
                      // Appeler le callback si fourni
                      if (onDismiss) {
                        onDismiss();
                      }
                    }}
                  ></Button>
                </div>

                <div className="d-flex d-flex justify-content-between fw-bold">
                  <div className={'d-flex align-items-center'}>
                    <div dangerouslySetInnerHTML={{ __html: message }} />
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default MessageToUser;
